import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Itemuom } from './item-uom';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class ItemuomService {
	
baseUrl = environment.baseUrl;

  private itemuomsUrl = this.baseUrl + '/api/itemuom';  // URL to web api
  private getitemuomlistUrl = this.baseUrl + '/api/itemuom/getitemuomlist';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getItemuoms (): Observable<Itemuom[]> {
    return this.http.get<Itemuom[]>(this.itemuomsUrl)
  }

  
  getItemuom(itemuomid: number): Observable<Itemuom> {
    const url = `${this.getitemuomlistUrl}/${itemuomid}`;
    return this.http.get<Itemuom>(url);
  }
 

}